'use client'

import { FC } from 'react'
import useI18n from 'Hooks/useI18n'
import { ANNIVERSARY_DEADLINE_TIME } from '@/constant/date'
import GemRewardDisplay from './components/GemRewardDisplay'
import CountdownTimer from './components/CountdownTimer'

const RelBannerCard: FC = () => {
  const { t } = useI18n()

  return (
    <div
      className="relative flex h-full w-full flex-col items-center justify-start bg-cover bg-center px-4 font-light"
      style={{
        backgroundImage: 'url(/activity/rel_banner.png)',
      }}
    >
      {/* 标题区 */}
      <div className="mt-[104px] flex flex-col text-center md:mt-[122px]">
        <p
          className="mb-[14px] px-1 text-[13px]"
          style={{ lineHeight: '16px' }}
        >
          {t('Chat & gain relationships with your favorite character.')}
        </p>
        <p className="text-[13px]" style={{ lineHeight: '20px' }}>
          {t('Top ')}
          <span className="text-[18px] text-[#FFDC6A]">100</span>
          {t(' winner ')}
        </p>
        <p className="mb-2 text-[13px]" style={{ lineHeight: '20px' }}>
          <span className="text-[18px] text-[#FFDC6A]">
            {/* i18n-ignore */ '250K'}
          </span>
          {t(' Gems prize pool.')}
        </p>
        <p className="mb-4 text-[13px] text-white/60">
          {/* i18n-ignore */ '11/24 - 12/01'}
        </p>
      </div>

      {/* 底部容器 - 奖励、倒计时、按钮 */}
      <div className="flex w-full flex-1 flex-col items-center justify-start gap-2">
        {/* 查看按钮 */}
        <div className="w-full">
          <button className="h-[26px] w-full rounded-full bg-black/20 text-[13px] font-medium leading-[26px] text-white hover:bg-white/30">
            {t('View')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default RelBannerCard
